var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-arrow-nav" },
    _vm._l(_vm.arrowNav, function(arrow, arrowIdx) {
      return _c(
        "div",
        {
          key: arrow,
          staticClass: "carousel-arrow-nav--arrow",
          class: [_vm.bemAdd(arrow.dir, "arrow")]
        },
        [
          _c(
            "button",
            {
              staticClass:
                "carousel-arrow-nav--button btn btn__bubble btn__overlay btn__large",
              attrs: {
                type: "button",
                disabled: _vm.isArrowDisabled[arrow.dir] ? true : null
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.changeHandler(_vm.activeIdx + arrow.change)
                }
              }
            },
            [
              _c("cmp-ink-ripple"),
              _vm._v(" "),
              _c("cmp-icon", {
                staticClass: "btn--bubble-icon",
                attrs: { symbol: arrow.icon, size: "small" }
              })
            ],
            1
          )
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e32e8f98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e32e8f98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/ui/carousel/carousel-arrow-nav/index.vue
// module id = 430
// module chunks = 5